import React from 'react';
import {
	GovLayout,
	GovLayoutColumn,
	GovSkeleton,
} from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import { useGlobalLocale } from '@gov-nx/core/service/translations/useGlobalLocale';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { LayoutGap } from '@gov-nx/ui/web/Layout/LayoutGap';
import { generateRandomNumber } from '@gov-nx/utils/common/Number/random';

const numberOfColumn = 3;
const faqItemsCount = generateRandomNumber(3, 10);

export interface CmsPageSkeletonProps {
	children: React.ReactNode;
}

export const CmsPageSkeleton = ({ children }: CmsPageSkeletonProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Page);
	const { t: tg } = useGlobalLocale();

	return (
		<>
			<GovLayout
				type="text"
				variant="left">
				<GovLayoutColumn>
					<main className="gap-(--templates-margin-3xl)!">
						{/* Page heading */}
						<LayoutGap gap="l">
							<GovSkeleton
								width="50px"
								height="20px"
								aria-label={tg('loading.wcag.processing')}
								className="my-2! ml-2! skeleton-brighter"
							/>
							<GovSkeleton
								width={generateRandomNumber(20, 60) + '%'}
								height="54px"
								aria-label={tg('loading.wcag.processing')}
								className="skeleton-brighter"
							/>
						</LayoutGap>
						<div>
							{/* CMS Description heading */}
							<GovSkeleton
								width="170px"
								height="24px"
								aria-label={tg('loading.wcag.processing')}
								className="skeleton-brighter"
							/>
						</div>
						<LayoutGap>{children}</LayoutGap>
					</main>
				</GovLayoutColumn>
			</GovLayout>
			<section className="mt-(--templates-margin-3xl)!">
				<h2>{t('mozna-hledate')}</h2>
				<div className="grid gap-6 [ md:grid-cols-3 ]">
					{/* CMS Related Items */}
					{Array(numberOfColumn)
						.fill({})
						.map((_, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<div key={index}>
								<GovSkeleton
									width="100%"
									height="92px"
									aria-label={tg('loading.wcag.processing')}
									className="skeleton-brighter rounded-2xl!"
								/>
							</div>
						))}
				</div>
			</section>
			<GovLayout
				type="text"
				variant="left">
				<GovLayoutColumn>
					<h2 className="mb-(--templates-margin-l)!">{t('casto-se-ptate')}</h2>
					{/* CMS - FAQ items	*/}
					{Array(faqItemsCount)
						.fill({})
						.map((_, index) => (
							<div
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								className="p-4">
								<GovSkeleton
									width={generateRandomNumber(25, 85) + '%'}
									height="24px"
									aria-label={tg('loading.wcag.processing')}
									className="flex! skeleton-brighter"
								/>
							</div>
						))}
				</GovLayoutColumn>
			</GovLayout>
		</>
	);
};
